
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  // Lifecycle Hooks
  beforeCreate() {
    console.log("componentBeforeCreate", this);
  },
  created() {
    console.log("componentCreated", this);
  },
  beforeMount() {
    console.log("componentBeforeMount", this);
  },
  mounted() {
    console.log("componentMounted", this);
  },
  beforeDestroy() {
    console.log("componentBeforeDestroy", this);
  },
  destroyed() {
    console.log("componentDestroyed", this);
  },
  // Component Data
  data: function () {
    // Must return an object
    return {
      daysSober: 405,
      group: false,
      individual: false,
      name: "Dustin",
      age: 41,
      like: ["Baseball", "Basketball", "Football"]
    };
  },
  // Component Methods
  methods: {
    openAlert: function () {
      var self = this;
      self.$app.dialog.alert("Hello World");
    },
    openHelpSheet: function (title, text) {
      var self = this;
      self.$$("#help-title").text(title);
      self.$$("#help-text").text(text);
      self.$app.sheet.open(".help-sheet");
    },
    toggle: function (val) {
      data[val] = !data[val];
    }
  },
  // Page Events
  on: {
    pageMounted: function (e, page) {
      console.log("pageMounted", page);
    },
    pageInit: function (e, page) {
      console.log("pageInit", page);
    },
    pageBeforeIn: function (e, page) {
      console.log("pageBeforeIn", page);
    },
    pageAfterIn: function (e, page) {
      console.log("pageAfterIn", page);
      page.app.toolbar.hide(".toolbar");
    },
    pageBeforeOut: function (e, page) {
      console.log("pageBeforeOut", page);
    },
    pageAfterOut: function (e, page) {
      console.log("pageAfterOut", page);
    },
    pageBeforeRemove: function (e, page) {
      console.log("pageBeforeRemove", page);
    }
  },
  id: '9c0d4e94fc',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>Sunday, July 28, 2019</div></div></div><div class=page-content><div class=block-title>Sobriety <span class=badge id=sobriety-help @click="openHelpSheet(\'Sobriety\', \'In this section you write about how your sobriety went on this day and what you did to achieve sobriety. You may also write about how you struggled and what you will do differently the next day.\')">?</span></div><div class="list inline-labels no-hairlines-md"><ul><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Days Sober</div><div class=item-input-wrap><input type=text placeholder=405> <span class=input-clear-button></span></div></div></li><li class="item-content item-input"><div class=item-inner><div class=item-input-wrap><textarea class=resizable placeholder="How my sobriety went..."></textarea></div></div></li></ul></div><div class=block-title>Soothing <span class=badge @click="openHelpSheet(\'Soothing\', \'In this section yo write about what you did to effectively soothe and how it helped you. You may also write about how you could be more efective in soothing the next day.\')">?</span></div><div class=list><ul><li><a class="item-link smart-select smart-select-init" data-open-in=popover><select name=spiritual multiple=multiple><option value=Prayer>Prayer</option><option value="Book of Mormon">Book of Mormon</option><option value=Temple>Temple</option><option value=Meditation>Meditation</option><option value=Sacrament>Sacrament</option></select><div class=item-content><div class=item-inner><div class=item-title>Spiritual</div></div></div></a></li><li><a class="item-link smart-select smart-select-init" data-open-in=popover><select name=physical multiple=multiple><option value=Weightlifting>Weightlifting</option><option value=Walk>Walk</option><option value=Run>Run</option><option value=Pickleball>Pickleball</option><option value=Basketball>Basketball</option><option value=Other>Other</option></select><div class=item-content><div class=item-inner><div class=item-title>Physical</div></div></div></a></li><li><a class="item-link smart-select smart-select-init" data-open-in=popover><select name=emotional multiple=multiple><option value=Weightlifting>Weightlifting</option><option value=Walk>Walk</option><option value=Run>Run</option><option value=Pickleball>Pickleball</option><option value=Basketball>Basketball</option><option value=Other>Other</option></select><div class=item-content><div class=item-inner><div class=item-title>Emotional</div></div></div></a></li><li><a class="item-link smart-select smart-select-init" data-open-in=popover><select name=social multiple=multiple><option value=Weightlifting>Weightlifting</option><option value=Walk>Walk</option><option value=Run>Run</option><option value=Pickleball>Pickleball</option><option value=Basketball>Basketball</option><option value=Other>Other</option></select><div class=item-content><div class=item-inner><div class=item-title>Social</div></div></div></a></li></ul></div><div class="list inline-labels no-hairlines-md"><ul><li class="item-content item-input"><div class=item-inner><div class=item-input-wrap><textarea class=resizable placeholder="Additional thoughts and notes..."></textarea></div></div></li></ul></div><div class=block-title>High Risks <span class=badge @click="openHelpSheet(\'High Risks\', \'This is the section in which you identify specific high risks that you encountered that may or may not have impacted your sobriety. You identify how you handled them and the success you had. You may also write what you could do to improve.\')">?</span></div><div class="list inline-labels no-hairlines-md"><ul><li class="item-content item-input"><div class=item-inner><div class=item-input-wrap><textarea class=resizable placeholder="High risks encountered..."></textarea></div></div></li></ul></div><div class=block-title>Tracking <span class=badge @click="openHelpSheet(\'Tracking Points\', \'This section allows you to track your progress on a daily basis. It also allows you to track the number of days of sobriety that you have and to keep track of the number of groups that you are attending so you know when you can move onto the next phase. There are approximately 550 points possible per month on the tracking system. We have found that if an individual is working hard and getting 90% or above on a monthly basis, they will be getting better.\')">?</span></div><div class="list inline-labels"><ul><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Pillars</div><div class=item-input-wrap><div class=row><div class=col-33><label class=checkbox><input type=checkbox><i class=icon-checkbox></i></label></div><div class=col-33><label class=checkbox><input type=checkbox><i class=icon-checkbox></i></label></div><div class=col-33><label class=checkbox><input type=checkbox><i class=icon-checkbox></i></label></div></div></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Therapy</div><div class=item-input-wrap><p class="segmented segmented-round"><button class="button button-round button-outline color-green ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.individual, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'button-active';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '" @click="toggle(\'individual\');">Individual</button> <button class="button button-round button-outline color-green ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.group, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'button-active';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '" @click="toggle(\'group\');">Group</button></p></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Therapy</div><div class=item-input-wrap><div class=row><div class=col-50><label class=checkbox><input type=checkbox><i class=icon-checkbox></i></label> Individual</div><div class=col-50><label class=checkbox><input type=checkbox><i class=icon-checkbox></i></label> Group</div></div></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Homework</div><div class=item-input-wrap><label class=checkbox><input type=checkbox><i class=icon-checkbox></i></label></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Sobriety</div><div class=item-input-wrap><div class="range-slider range-slider-init" data-label=true><input type=range value=5 min=0 max=10 step=1></div></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Other</div><div class=item-input-wrap><p class="segmented segmented-round"><button class="button button-round button-outline color-red">Acted Out</button> <button class="button button-round button-outline color-red">MB</button></p></div></div></li></ul></div><div class="block block-strong"><div class=row><div class="col-50 text-align-center">Today\'s Points<div class=point-value>16</div></div><div class="col-50 text-align-center">Number of Days Sober<div class=point-value>405</div></div></div></div><div class="block block-strong"><p>Component page is also compiled with Template7, but it has much more functionality. In addition to Template7 page it has lifecycle hooks, events handling and data managment.</p><p>It is useful to use Component page when you need page-specific logic.</p></div><div class=block-title>Events Handling</div><div class="block block-strong"><a href=# class="button button-raised" @click=openAlert>Open Alert</a></div><div class=block-title>Page Component Data</div><div class="block block-strong"><p>Hello! My name is ';
      r += c(ctx_1.name, ctx_1);
      r += '. I am ';
      r += c(ctx_1.age, ctx_1);
      r += ' years old.</p><p>I like to play:</p><ul>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.like, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<li>';
          r += c(ctx_2, ctx_2);
          r += '</li>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</ul></div><div class=block-title>Extended Context</div><div class="block block-strong"><p>Component page context as Template7 page context is also extended with some additional variables.</p><h4>$route</h4><p>Contains properties of the current route:</p><ul style=padding-left:25px><li><b>$route.url</b>: ';
      r += c(ctx_1.$route.url, ctx_1);
      r += '</li><li><b>$route.path</b>: ';
      r += c(ctx_1.$route.path, ctx_1);
      r += '</li><li><b>$route.params</b>: ';
      r += Template7Helpers.js.call(ctx_1, 'return JSON.stringify(this.$route.params)', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</li><li><b>$route.hash</b>: ';
      r += c(ctx_1.$route.hash, ctx_1);
      r += '</li><li><b>$route.query</b>: ';
      r += Template7Helpers.js.call(ctx_1, 'return JSON.stringify(this.$route.query)', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</li></ul><h4>$root</h4><p>Root data & methods:</p><ul style=padding-left:25px><li><b>$root.user.firstName</b>: ';
      r += c(ctx_1.$root.user.firstName, ctx_1);
      r += '</li><li><b>$root.user.lastName</b>: ';
      r += c(ctx_1.$root.user.lastName, ctx_1);
      r += '</li><li><a @click=$root.helloWorld()>$root.helloWorld()</a></li></ul><h4>$theme</h4><p>Currently active theme:</p><ul style=padding-left:25px><li><b>$theme.ios</b>: ';
      r += c(ctx_1.$theme.ios, ctx_1);
      r += '</li><li><b>$theme.md</b>: ';
      r += c(ctx_1.$theme.md, ctx_1);
      r += '</li><li><b>$theme.aurora</b>: ';
      r += c(ctx_1.$theme.aurora, ctx_1);
      r += '</li></ul></div></div><!-- Info help sheet --><div class="sheet-modal help-sheet"><div class=toolbar><div class=toolbar-inner><div class=left><div class=title id=help-title>Info</div></div><div class=right><a class="link sheet-close" href=#>Done</a></div></div></div><div class=sheet-modal-inner><div class=block><p id=help-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque ac diam ac quam euismod porta vel a nunc. Quisque sodales scelerisque est, at porta justo cursus ac.</p></div></div></div></div>';
      return r;
    }(this);
  },
  style: `
  .block {
    margin: 0;
  }
  .block-title {
    margin-top: var(--f7-block-title-margin-bottom);
  }
  #help-title {
    margin-top: var(--f7-block-title-margin-bottom);
  }
  .point-value {
    font-size: 36pt;
  }
`,
  styleScoped: false
};
    